import { encrypt, decrypt } from "./utilities";
import { ENV_NAME } from "../config";

const USER_SESSION = "USER_SESSION";
export const USER_SUBJECT = "subject";
export const USER_LOGIN_ID = "USER_LOGIN_ID";
export const USER_COMPANY_ID = "USER_COMPANY_ID";
export const USER_COMPANY_ROLE = "USER_COMPANY_ROLE";
export const USER_COMPANY_ROLE_ID = "USER_COMPANY_ROLE_ID";
export const USER_COMPANIES = "USER_COMPANIES";
export const USER_POLICIES = "USER_POLICIES";
export const secure = !(ENV_NAME === "test");

const SESSION_VARIABLES = [
    USER_SUBJECT,
    USER_LOGIN_ID,
    USER_COMPANY_ID,
    USER_COMPANY_ROLE,
    USER_COMPANY_ROLE_ID,
    USER_COMPANIES,
    USER_POLICIES
];

function parseSession() {
    let mysession = localStorage.getItem(USER_SESSION)
        ? localStorage.getItem(USER_SESSION)
        : null;
    if (!mysession) {
        return null;
    }
    try {
        const decryptedSession = decrypt(mysession);
        const myUserSession = JSON.parse(atob(decryptedSession));
        return myUserSession;
    } catch (_) {
        return null;
    }
}

function encodeSession(sessionObject, key) {
    try {
        let sessionString = JSON.stringify(sessionObject);
        sessionString = btoa(sessionString);
        const ecnryptedSessionString = encrypt(sessionString);
        localStorage.setItem(USER_SESSION, ecnryptedSessionString, {
            expires: 1,
            samesite: "strict",
            secure: secure
        });
    } catch (_) {
        localStorage.removeItem(USER_SESSION);
        console.log("error setting session");
    }
}

let UserSession = {
    get: key => {
        let mysession = parseSession();
        if (mysession && SESSION_VARIABLES.includes(key)) {
            return mysession[key] || null;
        } else {
            return null;
        }
    },
    set: (key, value) => {
        let mysession = parseSession() || {};
        if (mysession && SESSION_VARIABLES.includes(key)) {
            mysession[key] = value;
            encodeSession(mysession, key);
        }
    },
    delete: key => {
        let mysession = parseSession();
        if (mysession && SESSION_VARIABLES.includes(key)) {
            delete mysession[key];
            encodeSession(mysession);
        }
    },
    clear: () => {
        localStorage.removeItem(USER_SESSION);
    }
};

export default UserSession;



// WEBPACK FOOTER //
// ./src/common/userSession.js